import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import type {AlternativePFGroup} from '@/types/AlternativePFGroup.ts';

export const useModalStore = defineStore('modalStore', () => {
	const createPoModalOpen = ref(false);
	const createPoSuccessModalOpen = ref(false);
	const changeDeliveryAddressModalOpen = ref(false);
	const alternativePFModalOpen = ref(false);
	const alternativePFGroups = ref<AlternativePFGroup[]>([]);
	const currentAlternativePFIndex = ref(0);

	const currentAlternativePFGroup = computed(() =>
		alternativePFGroups.value[currentAlternativePFIndex.value] ?? null
	);

	const openAlternativePFModal = (groups: AlternativePFGroup[]) => {
		alternativePFGroups.value = groups;
		currentAlternativePFIndex.value = 0;
		alternativePFModalOpen.value = true;
	};

	const goToNextAlternativePFGroup = () => {
		const nextIndex = currentAlternativePFIndex.value + 1;
		if (nextIndex < alternativePFGroups.value.length) {
			currentAlternativePFIndex.value = nextIndex;
		} else {
			closeAlternativePFModal();
		}
	};

	const closeAlternativePFModal = () => {
		alternativePFModalOpen.value = false;
		alternativePFGroups.value = [];
		currentAlternativePFIndex.value = 0;
	};

	return {
		createPoModalOpen,
		createPoSuccessModalOpen,
		changeDeliveryAddressModalOpen,
		alternativePFModalOpen,
		currentAlternativePFGroup,
		openAlternativePFModal,
		goToNextAlternativePFGroup,
		closeAlternativePFModal,
	};
});
